<template>
  <div
    :class="{ required: data.required }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <div
      v-if="data.disabled"
      class="ui left icon input">
      <i class="calendar alternate outline icon"/>
      <input
        type="text"
        disabled
        :value="parseInput"
        :placeholder="$t(data.placeholder)">
    </div>
    <v-date-picker
      v-else
      :locale="$i18n.locale"
      :min-date="data.minDate"
      :max-date="data.maxDate"
      v-model="input">
      <div class="ui left icon action input">
        <i class="calendar alternate outline icon"/>
        <input
          type="text"
          readonly
          :value="parseInput"
          :placeholder="$t(data.placeholder)">
        <button
          class="ui basic icon button"
          type="button"
          @click="input = null">
          <i class="close icon"/>
        </button>
      </div>
    </v-date-picker>
  </div>
</template>

<script>
import 'v-calendar/lib/v-calendar.min.css'

export default {
  name: 'DateInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      validator: (value) => {
        return (value === null || ['string', 'number', 'undefined'].includes(typeof value))
      },
      required: true
    }
  },
  data () {
    return {
      input: this.value ? new Date(this.value) : null
    }
  },
  computed: {
    parseInput () {
      if (this.input) {
        return this.$d(this.input, 'short')
      } else {
        return ''
      }
    }
  },
  watch: {
    input (value) {
      this.$emit('input', value ? value.getTime() : null)
    }
  },
  mounted () {
    if (!this.value && this.data.hasOwnProperty('default')) {
      this.input = new Date(this.data.default)
      this.$emit('input', this.input.getTime())
    }
  }
}
</script>

<style scoped>

.input button {
  box-shadow: none !important;
  border: 1px solid rgba(34,36,38,.15) !important;
  border-left: none !important;
}

button i {
  line-height: 100%;
}

</style>
